//Perbėgusios avys ir karvės yra dedamos į bandos galą. 
//vienas state, keičiant ganyklą, keičiasi 


import './App.scss';
import './buttons.scss';
import Left from './Components/Left';
import Right from './Components/Right';
import getRandomInt from './Functions/rand';
import { useEffect, useState } from 'react';


function App() {

  const [animals, setAnimals] = useState(JSON.parse(localStorage.getItem('animals')) || [])

  useEffect(() => {

    localStorage.setItem('animals', JSON.stringify(animals));
  }

    , [animals]);





  const fillField = _ => {
    setAnimals([]);
    const cowNum = getRandomInt(5, 20);
    for (let i = 0; i < cowNum; i++) {

      setAnimals(c => [...c, { id: 'K' + String(getRandomInt(1, 9999999)).padStart(7, '0'), side: 'Left', type: 'cow', message: 'msgNoDisplay' }])
    }

    const sheepNum = getRandomInt(5, 20);
    for (let i = 0; i < sheepNum; i++) {
      setAnimals(s => [...s, { id: 'A' + String(getRandomInt(1, 9999999)).padStart(7, '0'), side: 'Right', type: 'sheep', message: 'msgNoDisplay' }])
    }

  }


  const emptyField = _ => {
    setAnimals(c => [])
  }


  return (
    <div className="App">
      <header className="App-header">
        <div>
          <button onClick={fillField}> Į GANYKLĄ!</button>

          <button onClick={emptyField}> IŠVALYTI!</button>

        </div>

        <div className='field'>
          <Left animals={animals} setAnimals={setAnimals} />
          <Right animals={animals} setAnimals={setAnimals} />
        </div>
      </header>
    </div>
  );
}

export default App;
